import _regeneratorRuntime from "D:\\agent\\_work\\82\\s\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/regenerator";
import _classCallCheck from "D:\\agent\\_work\\82\\s\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
import axios from "axios";
import { getApiHeader } from "./token";
import config from "./config";
export var Section = function Section() {
  _classCallCheck(this, Section);
};
export var BriefTestInfo = function BriefTestInfo() {
  _classCallCheck(this, BriefTestInfo);
};
export var InstitutionPopularTestsDTO = function InstitutionPopularTestsDTO() {
  _classCallCheck(this, InstitutionPopularTestsDTO);
};
var searchDetails = function searchDetails(keywords, orderBy, isAscending) {
  return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var url, keywordQuery, orderByQuery, response;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            url = "api/tests";
            if (keywords !== "") {
              keywordQuery = "keywords=".concat(keywords);
            }
            if (orderBy && isAscending) {
              orderByQuery = "orderBy=".concat(orderBy, "%20").concat(isAscending ? "ASC" : "DESC");
            }
            if (keywordQuery || orderByQuery) {
              url += "?".concat([keywordQuery, orderByQuery].filter(function (q) {
                return q !== undefined;
              }).join("&"));
            }
            _context.next = 6;
            return axios.get(url, {
              baseURL: config.apiUrl
            });
          case 6:
            response = _context.sent;
            return _context.abrupt("return", response.data);
          case 8:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
};
//API to fetch favorite tests options for VA users
var searchDetailsVA = function searchDetailsVA(keywords, orderBy, isAscending) {
  return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
    var url, keywordQuery, orderByQuery, response;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            url = "api/tests/VA";
            if (keywords !== "") {
              keywordQuery = "keywords=".concat(keywords);
            }
            if (orderBy && isAscending) {
              orderByQuery = "orderBy=".concat(orderBy, "%20").concat(isAscending ? "ASC" : "DESC");
            }
            if (keywordQuery || orderByQuery) {
              url += "?".concat([keywordQuery, orderByQuery].filter(function (q) {
                return q !== undefined;
              }).join("&"));
            }
            _context2.next = 6;
            return axios.get(url, {
              baseURL: config.apiUrl
            });
          case 6:
            response = _context2.sent;
            return _context2.abrupt("return", response.data);
          case 8:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
};
export var searchCategory = function searchCategory(categoryName) {
  return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
    var response;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 2;
            return axios.get("api/tests?categoryName=".concat(categoryName), {
              baseURL: config.apiUrl
            });
          case 2:
            response = _context3.sent;
            return _context3.abrupt("return", response.data);
          case 4:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
};
export var searchCategoryFaster = function searchCategoryFaster(categoryName) {
  return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
    var response;
    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            _context4.next = 2;
            return axios.get("api/tests/category-name/".concat(categoryName), {
              baseURL: config.apiUrl
            });
          case 2:
            response = _context4.sent;
            return _context4.abrupt("return", response.data);
          case 4:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));
};
var getDetails = function getDetails(testCode, institutionCode, orderingTestCode) {
  return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
    var response;
    return _regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            _context5.next = 2;
            return axios.get("api/tests/code/".concat(testCode).concat(institutionCode ? "?institutionCode=".concat(institutionCode) : "").concat(orderingTestCode ? "?orderingTestCode=".concat(orderingTestCode) : ""), {
              baseURL: config.apiUrl
            });
          case 2:
            response = _context5.sent;
            return _context5.abrupt("return", response.data);
          case 4:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5);
  }));
};
var getSections = function getSections(testCode) {
  return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
    var response, sections, result;
    return _regeneratorRuntime.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            _context6.next = 2;
            return axios.get("/api/Tests/code/".concat(testCode, "/sections"), {
              baseURL: config.apiUrl
            });
          case 2:
            response = _context6.sent;
            sections = response.data;
            result = sections.map(function (section) {
              return Object.assign(Object.assign({}, section), {
                setting: section.setting ? JSON.parse(section.setting) : null
              });
            });
            return _context6.abrupt("return", result);
          case 6:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6);
  }));
};
var getPairTest = function getPairTest(testCode) {
  return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee7() {
    var response, result;
    return _regeneratorRuntime.wrap(function _callee7$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            _context7.next = 2;
            return axios.get("/api/Tests/pair/".concat(testCode), {
              baseURL: config.apiUrl
            });
          case 2:
            response = _context7.sent;
            result = response.data;
            return _context7.abrupt("return", result);
          case 5:
          case "end":
            return _context7.stop();
        }
      }
    }, _callee7);
  }));
};
export var getClientTestCode = function getClientTestCode(precarveoutTC, hospitalCode) {
  return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee8() {
    var response, result;
    return _regeneratorRuntime.wrap(function _callee8$(_context8) {
      while (1) {
        switch (_context8.prev = _context8.next) {
          case 0:
            _context8.next = 2;
            return axios.get("/api/Tests/code/".concat(precarveoutTC, "/hospitalCode/").concat(hospitalCode, "/clientCode"), {
              baseURL: config.apiUrl
            });
          case 2:
            response = _context8.sent;
            result = response.data;
            return _context8.abrupt("return", result);
          case 5:
          case "end":
            return _context8.stop();
        }
      }
    }, _callee8);
  }));
};
export var getClientTestCodes = function getClientTestCodes(clientTestCodes) {
  return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee9() {
    var response, result;
    return _regeneratorRuntime.wrap(function _callee9$(_context9) {
      while (1) {
        switch (_context9.prev = _context9.next) {
          case 0:
            _context9.next = 2;
            return axios.get("/api/Tests/clientTestCodes", {
              baseURL: config.apiUrl,
              headers: {
                clientTestCodes: clientTestCodes.join(",")
              }
            });
          case 2:
            response = _context9.sent;
            result = response.data;
            return _context9.abrupt("return", result);
          case 5:
          case "end":
            return _context9.stop();
        }
      }
    }, _callee9);
  }));
};
export var getParentalTest = function getParentalTest(testCode) {
  return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee0() {
    var response, result;
    return _regeneratorRuntime.wrap(function _callee0$(_context0) {
      while (1) {
        switch (_context0.prev = _context0.next) {
          case 0:
            _context0.next = 2;
            return axios.get("/api/Tests/parental/".concat(testCode), {
              baseURL: config.apiUrl
            });
          case 2:
            response = _context0.sent;
            result = response.data;
            return _context0.abrupt("return", result);
          case 5:
          case "end":
            return _context0.stop();
        }
      }
    }, _callee0);
  }));
};
export var getPopularTestCodesByInstitution = function getPopularTestCodesByInstitution(insitutionCode) {
  return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee1() {
    var options, response, result;
    return _regeneratorRuntime.wrap(function _callee1$(_context1) {
      while (1) {
        switch (_context1.prev = _context1.next) {
          case 0:
            options = getApiHeader();
            _context1.next = 3;
            return axios.get("/api/Tests/".concat(insitutionCode, "/popular/details"), options);
          case 3:
            response = _context1.sent;
            result = response.data;
            return _context1.abrupt("return", result);
          case 6:
          case "end":
            return _context1.stop();
        }
      }
    }, _callee1);
  }));
};
export var getCategories = function getCategories() {
  return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee10() {
    var response;
    return _regeneratorRuntime.wrap(function _callee10$(_context10) {
      while (1) {
        switch (_context10.prev = _context10.next) {
          case 0:
            _context10.next = 2;
            return axios.get("api/categories", {
              baseURL: config.apiUrl
            });
          case 2:
            response = _context10.sent;
            return _context10.abrupt("return", response.data);
          case 4:
          case "end":
            return _context10.stop();
        }
      }
    }, _callee10);
  }));
};
export var getVAStations = function getVAStations(state) {
  return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee11() {
    var url, response;
    return _regeneratorRuntime.wrap(function _callee11$(_context11) {
      while (1) {
        switch (_context11.prev = _context11.next) {
          case 0:
            url = "api/vastation";
            if (state) {
              url += "?state=".concat(state);
            }
            _context11.next = 4;
            return axios.get(url, {
              baseURL: config.apiUrl
            });
          case 4:
            response = _context11.sent;
            return _context11.abrupt("return", response.data);
          case 6:
          case "end":
            return _context11.stop();
        }
      }
    }, _callee11);
  }));
};
export var createCustomPanel = function createCustomPanel(institutionCode, model) {
  return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee12() {
    var response;
    return _regeneratorRuntime.wrap(function _callee12$(_context12) {
      while (1) {
        switch (_context12.prev = _context12.next) {
          case 0:
            _context12.next = 2;
            return axios.post("api/Tests/".concat(institutionCode, "/custom-panel"), model, getApiHeader());
          case 2:
            response = _context12.sent;
            return _context12.abrupt("return", response.data);
          case 4:
          case "end":
            return _context12.stop();
        }
      }
    }, _callee12);
  }));
};
export var updateCustomPanel = function updateCustomPanel(id, clientTestCodeUpdate) {
  return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee13() {
    var response;
    return _regeneratorRuntime.wrap(function _callee13$(_context13) {
      while (1) {
        switch (_context13.prev = _context13.next) {
          case 0:
            _context13.next = 2;
            return axios.put("api/Tests//custom-panel/".concat(id, "/update"), clientTestCodeUpdate, getApiHeader());
          case 2:
            response = _context13.sent;
            return _context13.abrupt("return", response.data);
          case 4:
          case "end":
            return _context13.stop();
        }
      }
    }, _callee13);
  }));
};
export var getPanelGenes = function getPanelGenes(clientTestCode) {
  return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee14() {
    var response;
    return _regeneratorRuntime.wrap(function _callee14$(_context14) {
      while (1) {
        switch (_context14.prev = _context14.next) {
          case 0:
            _context14.next = 2;
            return axios.get("api/Tests/clientTestCode/".concat(clientTestCode, "/genes"), {
              baseURL: config.apiUrl
            });
          case 2:
            response = _context14.sent;
            return _context14.abrupt("return", response.data);
          case 4:
          case "end":
            return _context14.stop();
        }
      }
    }, _callee14);
  }));
};
export var getTestAddOns = function getTestAddOns(code) {
  return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee15() {
    var response;
    return _regeneratorRuntime.wrap(function _callee15$(_context15) {
      while (1) {
        switch (_context15.prev = _context15.next) {
          case 0:
            _context15.next = 2;
            return axios.get("api/Tests/code/".concat(code, "/add-on-tests"), {
              baseURL: config.apiUrl
            });
          case 2:
            response = _context15.sent;
            return _context15.abrupt("return", response.data);
          case 4:
          case "end":
            return _context15.stop();
        }
      }
    }, _callee15);
  }));
};
export var getTestConsents = function getTestConsents(code, category, institutionCode) {
  return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee16() {
    var response;
    return _regeneratorRuntime.wrap(function _callee16$(_context16) {
      while (1) {
        switch (_context16.prev = _context16.next) {
          case 0:
            _context16.next = 2;
            return axios.get("api/Tests/code/".concat(code, "/consents"), {
              baseURL: config.apiUrl,
              params: {
                category: category,
                institutionCode: institutionCode
              }
            });
          case 2:
            response = _context16.sent;
            return _context16.abrupt("return", response.data);
          case 4:
          case "end":
            return _context16.stop();
        }
      }
    }, _callee16);
  }));
};
export var getOrderableTests = function getOrderableTests(keywords, top, skip, orderBy) {
  return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee17() {
    var response;
    return _regeneratorRuntime.wrap(function _callee17$(_context17) {
      while (1) {
        switch (_context17.prev = _context17.next) {
          case 0:
            _context17.next = 2;
            return axios.get("api/Tests/online-orderable?keywords=".concat(keywords, "&skip=").concat(skip, "&top=").concat(top, "&orderBy=").concat(orderBy), {
              baseURL: config.apiUrl
            });
          case 2:
            response = _context17.sent;
            return _context17.abrupt("return", response.data);
          case 4:
          case "end":
            return _context17.stop();
        }
      }
    }, _callee17);
  }));
};
export default {
  searchDetails: searchDetails,
  searchCategory: searchCategory,
  searchCategoryFaster: searchCategoryFaster,
  getDetails: getDetails,
  getSections: getSections,
  getPairTest: getPairTest,
  getParentalTest: getParentalTest,
  getClientTestCode: getClientTestCode,
  getClientTestCodes: getClientTestCodes,
  getPopularTestCodesByInstitution: getPopularTestCodesByInstitution,
  getCategories: getCategories,
  getVAStations: getVAStations,
  createCustomPanel: createCustomPanel,
  updateCustomPanel: updateCustomPanel,
  getPanelGenes: getPanelGenes,
  getTestAddOns: getTestAddOns,
  getTestConsents: getTestConsents,
  getOrderableTests: getOrderableTests,
  searchDetailsVA: searchDetailsVA
};